import { render, staticRenderFns } from "./ExpenseList.vue?vue&type=template&id=384fcaa5&scoped=true"
import script from "./ExpenseList.vue?vue&type=script&lang=js"
export * from "./ExpenseList.vue?vue&type=script&lang=js"
import style0 from "./ExpenseList.vue?vue&type=style&index=0&id=384fcaa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fcaa5",
  null
  
)

export default component.exports